import { apiCall } from '../utils/apiUtils';

/**
 * Fetch the authenticated user's current wallet state.
 * Returns { availableCredits, trialCreditsClaimed, creditCosts, accountStatus, ... }
 */
export async function fetchWallet() {
  return apiCall('/billing/wallet', null, { method: 'GET' });
}

/**
 * Fetch the last N ledger entries for the authenticated user.
 */
export async function fetchLedger(pageSize = 20) {
  return apiCall('/billing/ledger', null, {
    method: 'GET',
    params: { page_size: pageSize },
  });
}

/**
 * Fetch available credit packs (public, no auth required).
 */
export async function fetchPacks() {
  return apiCall('/billing/packs', null, { method: 'GET' });
}

/**
 * Start a Stripe Checkout session for purchasing credits.
 * Redirects the browser to the Stripe-hosted checkout page.
 * @param {string} packId  e.g. 'launch_pack'
 */
export async function startCheckout(packId = 'launch_pack') {
  const result = await apiCall('/billing/create-checkout-session', { packId }, { method: 'POST' });
  if (result?.url) {
    window.location.href = result.url;
  }
  return result;
}

/**
 * Human-readable credit cost labels for display.
 */
export const FEATURE_LABELS = {
  blog_generation: '5 credits',
  blog_improve: '3 credits',
};

/**
 * Return true if the user has enough credits for a feature.
 */
export function hasEnoughCredits(wallet, feature) {
  if (!wallet) return false;
  const cost = wallet.creditCosts?.[feature] ?? 0;
  return wallet.availableCredits >= cost;
}
